var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarineVisibilitySensorL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 499,
    height: 415,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "fx0",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%",
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "discrete",
    tableValues: "0 0"
  }), /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.631373,
    intercept: 0
  })), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "6.875 6.875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 996,
    width: 499,
    height: 415
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.5 1018.5 431.5 1374.5 871.5 1374.5ZM402 996 901 996 901 1411 402 1411Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -3,
    width: 505,
    height: 424
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 501,
    height: 417
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "translate(-402 -996)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    filter: "url(#fx0)",
    transform: "translate(401 995)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4999 386.375 250.5 30.375 470.5 386.375Z",
    stroke: "#000000",
    strokeWidth: 17,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 0.921569,
    fill: "#EC6920",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M431.5 1374.5 651.5 1018.5 871.5 1374.5Z",
    stroke: "#000000",
    strokeWidth: 17.1875,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeOpacity: 0.921569,
    fill: "#EC6920",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarineVisibilitySensorL);
export default __webpack_public_path__ + "static/media/MarineVisibilitySensorL.c1194c2f810c1d31fa2e80623167d95c.svg";
export { ForwardRef as ReactComponent };